import { render, staticRenderFns } from "./ChemicalElementValue.vue?vue&type=template&id=f4b0b0b8&"
import script from "./ChemicalElementValue.vue?vue&type=script&lang=js&"
export * from "./ChemicalElementValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports